import Scaler from './Scaler.js';
import Tone from 'tone';

const WAIT_TIME = 300; // ms

class Modulator {
    constructor(sequencerEngine, mixSession, context, number) {
        this.initialBulkValues = {};
        this.sequencerEngine = sequencerEngine;
        this.store = sequencerEngine.store;
        this.context = context;
        this.number = number;

        this.idToParameter = {};
        this.parameterToScaler = {};
        this.parameterIdToVoiceToNode = {};
        this.parameters = [];
    }

    getType() {
        return undefined;
    }

    connect(audioNode, parameter, voiceNumber) {
        if (audioNode === undefined) {
            let scaler = new Scaler(parameter.min, parameter.max);
            this.parameterToScaler[parameter.id] = scaler;
            return;
        }

        this.idToParameter[parameter.id] = parameter;
 
        let chain = this.getChain(parameter, audioNode);
        this.getModulator().connect(chain[0]);
        for (let i=0; i < chain.length - 1; i++) {
            chain[i].connect(chain[i+1]);
        }
        // this.getModulator().chain(... chain);
        
        if (this.parameterIdToVoiceToNode[parameter.id] ===undefined) {
            this.parameterIdToVoiceToNode[parameter.id] = {
            };
        }

        this.parameterIdToVoiceToNode[parameter.id][voiceNumber] = chain;

        return chain;
    }

    replaceParameterIds(oldId, newId, parameter) {
        if (oldId === newId) {
            return;
        }
        let voiceToNode = this.parameterIdToVoiceToNode[oldId];
        this.parameterIdToVoiceToNode[newId] = voiceToNode;
        let scaler = this.parameterToScaler[oldId];
        if (scaler) {
            this.parameterToScaler[newId] = scaler;
        }
        this.idToParameter[newId] = parameter;

        delete this.parameterIdToVoiceToNode[oldId];
        delete this.parameterToScaler[oldId];
        delete this.idToParameter[oldId];
    }

    disconnect(audioNode, parameter, voiceNumber) {
        if (!this.parameterIdToVoiceToNode || this.parameterIdToVoiceToNode[parameter.id] === undefined) {
            return;
        }
        delete this.idToParameter[parameter.id];
        let chain = this.parameterIdToVoiceToNode[parameter.id][voiceNumber];
        delete this.parameterIdToVoiceToNode[parameter.id][voiceNumber];
        if (Object.keys(this.parameterIdToVoiceToNode[parameter.id]).length === 0) {
            delete this.parameterIdToVoiceToNode[parameter.id];
        }
        if (this.parameterToScaler[parameter.id] !== undefined) {
            delete this.parameterToScaler[parameter.id];
        }
        let modulator = this.getModulator();
        if (chain === undefined || !modulator) {
            return;
        }

        let scale = this.getScaleFromChain(chain);
        scale.min = 0;
        scale.max = 0;
        modulator.disconnect(chain[0]);

        for (let i=0; i < chain.length - 1; i++) {
            chain[i].disconnect(chain[i + 1]);
        }
        this.releaseChain(chain);
    }

    disposeParameters() {
        this.parameters.forEach(p => p.dispose(false));
    }

    disconnectAllModulators() {
        this.parameters.forEach(param => param.disconnectFromAllModulators());
   }

    getScaleForParameter(parameter, voice=0) {
        if (this.parameterToScaler[parameter.id]) {
            return this.parameterToScaler[parameter.id];
        }
        if (!this.parameterIdToVoiceToNode) {
            return undefined;
        }
        let voiceToNode  = this.parameterIdToVoiceToNode[parameter.id];
        if (voiceToNode === undefined) {
            return undefined;
        }
        let chain = voiceToNode[voice];
        return this.getScaleFromChain(chain);
    }
   
    getDepthForParameter(parameter, voice=0) {
         let voiceToNode  = this.parameterIdToVoiceToNode[parameter.id];
        if (voiceToNode === undefined) {
            return undefined;
        }
        let chain = voiceToNode[voice];
        return this.getDepthFromChain(chain);
    }
}

export default Modulator;
